import { createSelector } from 'redux-orm';

import orm from '../orm';
import { isLocalId } from '../utils/local-id';

export const makeSelectListById = () =>
  createSelector(
    orm,
    (_, id) => id,
    ({ List }, id) => {
      const listModel = List.withId(id);

      if (!listModel) {
        return listModel;
      }

      return {
        ...listModel.ref,
        isPersisted: !isLocalId(id),
      };
    },
  );

export const selectListById = makeSelectListById();

export const makeSelectCardIdsByListId = () =>
  createSelector(
    orm,
    (_, id) => id,
    ({ List }, id) => {
      const listModel = List.withId(id);

      if (!listModel) {
        return listModel;
      }

      return listModel.getFilteredOrderedCardsModelArray().map((cardModel) => cardModel.id);
    },
  );

export const selectCardIdsByListId = makeSelectCardIdsByListId();

// FAMILY-EXT: матрица Эйзенхауэра — карточки списка, сгруппированные
// по квадрантам. Используется только когда list.viewMode='eisenhower'.
// Применяет уже отфильтрованный набор (filterText/users/labels/hidden),
// чтобы фильтры доски действовали и в матрице.
export const makeSelectCardIdsByQuadrant = () =>
  createSelector(
    orm,
    (_, id) => id,
    ({ List }, id) => {
      const listModel = List.withId(id);

      if (!listModel) {
        return { q1: [], q2: [], q3: [], q4: [], unassigned: [] };
      }

      const grouped = { q1: [], q2: [], q3: [], q4: [], unassigned: [] };
      listModel.getFilteredOrderedCardsModelArray().forEach((cardModel) => {
        const q = cardModel.eisenhowerQuadrant;
        if (q === 'q1' || q === 'q2' || q === 'q3' || q === 'q4') {
          grouped[q].push(cardModel.id);
        } else {
          grouped.unassigned.push(cardModel.id);
        }
      });
      return grouped;
    },
  );

export const selectCardIdsByQuadrant = makeSelectCardIdsByQuadrant();

export default {
  makeSelectListById,
  selectListById,
  makeSelectCardIdsByListId,
  selectCardIdsByListId,
  makeSelectCardIdsByQuadrant,
  selectCardIdsByQuadrant,
};
